import React from "react";
import { Dialog, DialogContent, DialogFooter, DialogHeader } from "@/components/ui/dialog";
import { DialogTitleWithBug } from "@/components/ui/dialog-title-with-bug";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, Mic, MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";

interface MobileModePromptProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onDashboard: () => void;
  onVoice: () => void;
  onChat: () => void;
}

export const MobileModePrompt: React.FC<MobileModePromptProps> = ({
  isOpen,
  onOpenChange,
  onDashboard,
  onVoice,
  onChat,
}) => {
  const location = useLocation();

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitleWithBug
            popupName="Mobile Mode Selector"
            popupContext={location.pathname}
            isOpen={isOpen}
          >
            Choose your mode
          </DialogTitleWithBug>
        </DialogHeader>

        <div className="grid grid-cols-1 gap-3">
          <Button onClick={onDashboard} className="w-full justify-start gap-2" variant="outline">
            <LayoutDashboard className="h-4 w-4" />
            Dashboard mode
          </Button>
          <Button onClick={onVoice} className="w-full justify-start gap-2 bg-primary text-primary-foreground hover:bg-primary/90">
            <Mic className="h-4 w-4" />
            Voice mode
          </Button>
          <Button onClick={onChat} className="w-full justify-start gap-2" variant="secondary">
            <MessageCircle className="h-4 w-4" />
            Chat mode
          </Button>
        </div>

        <DialogFooter>
          <p className="text-xs text-muted-foreground">
            You can change this anytime from the header actions.
          </p>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
